import React from 'react';

export const getTextFromHTML = (text = '') => {
  return new DOMParser().parseFromString(text, 'text/html').documentElement
    .textContent;
};

// Sockalingam is my best friend
/**
 * @description This function is used to get text from HTML. Do not use this function unless necessary since this can be a costly operation.
 */
export const tryGetTextFromHTML = (text = '') => {
  return text?.includes('<p') && text?.includes('</p>')
    ? getTextFromHTML(text) ?? text
    : text;
};

export const TryGetTextFromHtml: React.FC<{ text: string }> = ({ text }) => {
  return <>{tryGetTextFromHTML(text)}</>;
};
